
import React, { useState, useEffect } from 'react';
import { BASE_URL, instanceAxios, convertDateStr } from "../../config";
import { toast } from "react-toastify";

export default function DownloaderList(props) {
    const [fillData, SetFillData] = useState([]);
    const [FristRecord, SetFristRecord] = useState(1);
    const [EndRecord, SetEndRecord] = useState(10);
    const [totalRecord, SettotalRecord] = useState(0);

    const GetListData = (_FristRecord, _EndRecord) => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/DownloadFile.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'GetListWithoutFile',
                FristRecord: _FristRecord,
                EndRecord: 10
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {
                    SetFillData(response.data);                    

                }
                else
                    SetFillData([]);
            })
            .catch((err) => {

            })

    }

    const GetCountRecord = () => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/DownloadFile.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'GetCountRecord',
               
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {
                    SettotalRecord(response.data[0].CountId);                   

                }
                else
                    SettotalRecord(0);
            })
            .catch((err) => {

            })

    }
    const DeleteClcik = (Id) => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/DownloadFile.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Id: Id,
                Method: 'Delete'
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {
                    toast.warning("حذف شد");
                }
                GetListData();
            })
            .catch((err) => {

            })
    }

    const Paging = (state) => {
        switch (state) {
            case "Frist":
                {
                    SetFristRecord(1);
                    SetEndRecord(10);
                    GetListData(1,10);
                    break;
                }
            case "Pre":
                {
                    if (FristRecord != 1) {
                        //console.log("FristRecord - 10", FristRecord - 10);
                        //console.log("EndRecord - 10", EndRecord - 10);
                        SetFristRecord(FristRecord - 10);
                        SetEndRecord(EndRecord - 10);
                        GetListData(FristRecord - 10, EndRecord - 10);
                    }

                    break;
                }
            case "Next":
                {
                    if (totalRecord > EndRecord) {
                        console.log("FristRecord + 10", FristRecord + 10);
                        console.log("EndRecord + 10", EndRecord + 10);
                        SetFristRecord(FristRecord + 10);
                        SetEndRecord(EndRecord + 10);
                        GetListData(FristRecord + 10, EndRecord + 10);
                    }
                    break;
                }
            case "Last":
                {
                    var A = totalRecord / 10;
                    SetFristRecord(A * 10);
                    SetEndRecord((A + 1) * 10);
                    GetListData(A * 10, (A + 1) * 10);
                    break;
                }
               
        }
    }
    useEffect(() => {
        GetListData(FristRecord, EndRecord);
        GetCountRecord();
    }, [])
    return (
        <div className="row">
            <div className="col-lg-12 col-md-12 col-xs-12">
                <div className="box" style={{ borderBottom: "5px solid #b8bec8" }}>
                    <div className="box-header" style={{ borderBottom: "3px solid #b8bec8" }}>
                        <h3 className="box-title"> فهرست محصولات</h3>

                        <div className="box-tools">
                            <div className=" pull-left" style={{ display: 'inline-flex' }}>
                                <div style={{ marginLeft: '10px', marginTop: "auto" }} ><span title="از رکورد" style={{ color: "#e8a7a7" }}> {FristRecord}</span>-<span title="تا رکورد" style={{ color: "#e8a7a7" }}>{EndRecord}</span>/<span style={{ color: "orange" }} title="تعداد کل رکوردها">{totalRecord}</span></div>
                                <div className="btn-group">
                                    <button type="button" title="اولین رکورد" onClick={(e) => Paging('Frist')} className="btn btn-default btn-sm" style={{ fontSize: "14px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-chevron-right"></i><i className="icon ion-chevron-right"></i></button>
                                    <button type="button" title="رکورد قبلی" onClick={(e) => Paging('Pre')} className="btn btn-default btn-sm" style={{ fontSize: "14px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-chevron-right"></i></button>
                                    <button type="button" title="رکورد بعدی" onClick={(e) => Paging('Next')} className="btn btn-default btn-sm" style={{ fontSize: "14px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-chevron-left"></i></button>
                                    <button type="button" title="آخرین رکورد" onClick={(e) => Paging('Last')} className="btn btn-default btn-sm" style={{ fontSize: "14px", backgroundColor: "#e6dcdc", marginLeft: "6px" }}><i className="icon ion-chevron-left"></i><i className="icon ion-chevron-left"></i></button>
                                    <button type="button" title="بروز رسانی فهرست" onClick={(e) => GetListData()} className="btn btn-default btn-sm" style={{ fontSize: "16px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-refresh"></i></button>
                                    <button type="button" title="جدید" onClick={(e) => props.onSetshowlist(1, '', '')} className="btn btn-default btn-sm" style={{ fontSize: "16px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-plus-round"></i></button>
                                </div>

                            </div>
                            <div className="input-group input-group-sm" style={{ width: "150px", marginLeft: "60px" }}>
                                <input type="text" name="table_search" className="form-control pull-right" placeholder="جستجو" />

                                <div className="input-group-btn" >
                                    <button style={{ backgroundColor: "#e3dcdc" }} className="btn btn-default"><i className="fa fa-search"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="box-body table-responsive " style={{ minHeight: "calc(80vh)" }}>
                        <table className="table table-hover" >
                            <thead>
                                <tr style={{ borderTop: "0px solid currentColor", lineHeight: "45px", backgroundColor: "rgba(88, 195, 213, 0.53)" }}>
                                    <th>ردیف</th>
                                    <th style={{ width: "15vw" }}>موضوع</th>
                                    <th>دسته بندی</th>
                                    <th>نوع فایل</th>
                                    <th>قیمت </th>
                                    <th>تاریخ انتشار</th>
                                    <th style={{ width: "50vw" }}>متن زیر تصویر</th>

                                    <th style={{ fontSize: "12px", width: "30px" }}></th>
                                    <th style={{ fontSize: "12px", width: "30px" }}></th>
                                    <th style={{ fontSize: "12px", width: "30px" }}></th>
                                    <th style={{ fontSize: "12px", width: "30px" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                { fillData !== null && fillData.length != 0 ?
                                    fillData.map((item, i) => {
                                        return <tr key={i} style={{ verticalAlign: "top", fontSize: "12px", borderTop: "1px solid currentColor", lineHeight: "30px" }}>
                                            <td style={{ width: "40px", textAlign: "center" }} scope="row">{(FristRecord+i )}</td>
                                            <td style={{ width: "15vw" }}>
                                                <i className="fa fa-cloud-download" style={{ color: "orangered", fontSize: "20px" }}></i><span className="label label-success" style={{ marginTop: "-3px", position: "absolute", marginRight: "-6px" }}>{item.Count_Like === null ? 0 : item.Count_Like}</span>
                                                <i className="fa fa-thumbs-o-up" style={{ color: "orangered", fontSize: "20px", marginRight: "10px" }} ></i><span className="label label-success" style={{ marginTop: "-3px", position: "absolute", marginRight: "-6px" }}>{item.Count_Download === null ? 0 : item.Count_Download}</span>
                                                <span style={{ marginRight: "10px" }}>{item.Subject}</span>                                                
                                            </td>
                                            <td><span style={{ color: "blue" }}>{item.categoryTitle}</span>/<span style={{color:"green"}}>{item.categorysubjectTitle}</span>
                                                {item.Isfavorites === 1 && <span style={{ marginRight: "10px", color: "orange" }}><br />محبوب ترین ها</span>}
                                                </td>
                                            <td>{item.typeShow === 2 ? "لینکی" : "دانلودی"}</td>
                                            <td>{item.price === null ? "رایگان" : item.price}</td>
                                            <td>{convertDateStr(new Date(item.CreateDate) / 1000, true)}</td>
                                            <td style={{ width: "50vw", lineHeight: "initial", textAlign: "justify" }} title={item.TitleUnderPic}>{item.TitleUnderPic.length > 160 ? item.TitleUnderPic.substring(0, 160) + "..." : item.TitleUnderPic}</td>


                                            <td style={{ width: "30px" }} onClick={(e) => props.onSetshowlist(1, item.Id, '')} title="ویرایش">
                                                <div className="btn btn-default btn-xs"><i className="fa fa-edit" style={{ fontSize: "16px", color: "#f08410", cursor: "pointer" }}></i>
                                                </div>
                                            </td>
                                            <td style={{ width: "30px" }} onClick={(e) => DeleteClcik(item.Id)} title="حذف رکورد">
                                                <div className="btn btn-default btn-xs">
                                                    <i className="fa fa-remove" style={{ fontSize: "16px", cursor: "pointer", color: "#f08410" }}></i>
                                                </div>
                                            </td>

                                            <td style={{ width: "50px" }} onClick={(e) => props.onSetshowlist(2, item.Id, item.Subject)} title="فهرست نظرات">
                                                <div className="btn btn-default btn-xs">
                                                    <i className="fa fa-comment" style={{ fontSize: "16px", cursor: "pointer", color: "#f08410" }}></i>
                                                </div>
                                                {item.Count_Comment !== null && item.Count_Comment !== 0 && <span className="label label-success" style={{ marginTop: "-3px", position: "absolute", marginRight: "-6px" }}>{item.Count_Comment === null ? 0 : item.Count_Comment}</span>}

                                            </td>
                                            <td style={{ width: "30px" }} onClick={(e) => props.onSetshowlist(3, item.Id, item.Subject)} title="فهرست درخواست فایل ">
                                                <div className="btn btn-default btn-xs">
                                                    <i className="fa fa-download" style={{ fontSize: "16px", cursor: "pointer", color: "#f08410" }}></i>
                                                </div>
                                                {item.CountQuestion !== null && item.CountQuestion !== 0 && <span className="label label-success" style={{ marginTop: "-3px", position: "absolute", marginRight: "-6px" }}>{item.CountQuestion === null ? 0 : item.CountQuestion}</span>}
                                            </td>
                                        </tr>
                                       
                                }) 
                                    :<tr style={{ borderTop: "0px solid currentColor", lineHeight: "200px", textAlign: "center", color: "#ac5252" }}><td colSpan={10} ><h4> رکوردی ثبت نشده است</h4>
                                    </td></tr>
                            }
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                    </div>

                </div>

            </div>
        </div>

    );
}